<template>
  <div class="mv3">
    <span class="b">{{ tableLabel }}</span>
    <table class="rawTable">
      <thead>
        <th
          v-for="col in columns"
          :key="col.id + instance">{{ col.name }}<br>{{ col.id }}</th>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in tableData"
          :key="'row' + instance + index">
          <td
            v-for="col in columns"
            :key="col.id + instance">{{ row[col.id] || '' }}</td>
        </tr>
      </tbody>
    </table>
    <a
      href="#"
      @click.prevent="copyToClipboard(tableData)">Copy tableData to clipboard</a>
    <br>
    <a
      href="#"
      @click.prevent="copyToClipboard(lku)">Copy lku to clipboard</a>
      <!-- {{ tableData }} -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import clipboardutil from '../../clipboardutil';
// import _ from 'lodash';


export default {
  name: 'SPTempDisplayData',
  props: {
    instance: {
      type: Number,
      default: 0,
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    tableLabel: {
      type: String,
      default: 'Table data:',
    },
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      // spData: state => state.SP.spData,
    }),
    // columns() {
    //   // since some rows may have additional columns due to nulls in the data
    //   return _(this.spData).reduce((acc, row) => _.assign(acc, row), {});
    // },
    columns() {
      return [
        { id: 'qi', name: 'QuestionId' },
        { id: 'yr', name: 'YearId' },
        { id: 'multistrat', name: 'Multistrat' },
        { id: 'sc1', name: 'StratificationCategoryId1' },
        { id: 's1', name: 'StratificationId1' },
        { id: 'sc2', name: 'StratificationCategoryId2' },
        { id: 's2', name: 'StratificationId2' },
        { id: 'rs', name: 'ResponseId' },
        { id: 'dvt', name: 'DataValueTypeId' },
        { id: 'dv', name: 'Data_Value_Alt' },
        { id: 'fn', name: 'Data_Value_Footnote_Symbol' },
        { id: 'lci', name: 'Low_Confidence_Limit' },
        { id: 'hci', name: 'High_Confidence_Limit' },
        { id: 'wn', name: 'Weighted_Number' },
      ];
    },
  },
  methods: {
    copyToClipboard(obj) {
      clipboardutil.copyTextToClipboard(JSON.stringify(obj));
    },
  },

};
</script>

<style scoped>
  .b {
    font-weight: bold;
  }

  .mv3 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  table.rawTable {
    font-size: smaller;
    font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    border-spacing: 0;
    width: 100%;
}


.rawTable td, .rawTable th {
    border: 1px solid #ddd;
    text-align: left;
    padding: 2px;
}

.rawTable tr:nth-child(even){background-color: #f2f2f2}

.rawTable th {
    padding-top: 11px;
    padding-bottom: 11px;
    background-color: #4CAF50;
    color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/SP/SPTempDisplayRawSPData.vue